import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import { Stack, Tooltip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getReportVisitSaleMonth } from "../../redux/handlers/report/getReportVisitSaleMonth.handler";
import { getReportVisitSaleMonthList } from "../../redux/handlers/report/getReportVisitSaleMonthList.handler";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import StoreIcon from "@mui/icons-material/Store";
import ButtonMui from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th"; // ใส่ locale ไทย
var COMPENSATION_LEVELS = [
    {
        label: "น้อยกว่า 35%",
        rate: "0.25%",
        color: "#dc3545"
    },
    {
        label: "35–44%",
        rate: "0.38%",
        color: "#fd7e14"
    },
    {
        label: "45–64%",
        rate: "0.50%",
        color: "#b8860b"
    },
    {
        label: "65–84%",
        rate: "0.75%",
        color: "#0d6efd"
    },
    {
        label: "ตั้งแต่ 85%",
        rate: "1.00%",
        color: "#198754"
    }
];
var getCompensationColor = function(rate) {
    var value = Number(rate);
    if (value >= 1) return "#198754";
    if (value >= 0.75) return "#0d6efd";
    if (value >= 0.5) return "#b8860b";
    if (value >= 0.38) return "#fd7e14";
    return "#dc3545";
};
export function ReportStoreVisitAppointment() {
    var _summary_top_active_sale, _summary_top_active_sale1, _summary_top_active_sale2;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState(new Date()), 2), month = _useState1[0], setMonth = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), saleId = _useState2[0], setSaleId = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionSale = _useState3[0], setOptionSale = _useState3[1];
    var _useState4 = _sliced_to_array(useState({}), 2), summary = _useState4[0], setSummary = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), columns = _useState5[0], setColumns = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tableData = _useState6[0], setTableData = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        show: false,
        title: "",
        items: []
    }), 2), branchModal = _useState7[0], setBranchModal = _useState7[1];
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var getReportVisitSaleMonthReducer = useAppSelector(function(state) {
        return state.getReportVisitSaleMonthReducer;
    });
    var formatSaleLabel = function(fullName, nickName) {
        var name = fullName ? fullName.trim() : "";
        var nname = nickName ? nickName.trim() : "";
        if (name && nname) {
            return "".concat(name, " (").concat(nname, ")");
        }
        if (name) {
            return name;
        }
        if (nname) {
            return nname;
        }
        return "-";
    };
    var saleDisplayMap = useMemo(function() {
        var _allSetUserReducer_data;
        var saleMap = new Map();
        if ((_allSetUserReducer_data = allSetUserReducer.data) === null || _allSetUserReducer_data === void 0 ? void 0 : _allSetUserReducer_data.data) {
            allSetUserReducer.data.data.filter(function(user) {
                return user.sys_user_role_id == 3;
            }).forEach(function(user) {
                saleMap.set(user.sys_user_id, formatSaleLabel(user.sys_user_fullname, user.sys_user_nname));
            });
        }
        return saleMap;
    }, [
        allSetUserReducer.data
    ]);
    var handleOpenBranchModal = function(title) {
        var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        setBranchModal({
            show: true,
            title: title,
            items: items
        });
    };
    var handleCloseBranchModal = function() {
        setBranchModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                show: false
            });
        });
    };
    useEffect(function() {
        dispatch(getReportVisitSaleMonth({
            month: moment(month).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    // dispatch(getReportVisitSaleMonthList({}, { modalObj, setModalObj }));
    }, [
        month
    ]);
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(allSetUserReducer.isFetching || getReportVisitSaleMonthReducer.isFetching);
    }, [
        allSetUserReducer.isFetching,
        getReportVisitSaleMonthReducer.isFetching,
        setIsLoading
    ]);
    useEffect(function() {
        return function() {
            return setIsLoading(false);
        };
    }, [
        setIsLoading
    ]);
    useEffect(function() {
        if (allSetUserReducer.data) {
            var arr = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            allSetUserReducer.data.data.filter(function(v) {
                return v.sys_user_role_id == 3;
            }).forEach(function(ele) {
                return arr.push({
                    value: ele === null || ele === void 0 ? void 0 : ele.sys_user_id,
                    label: formatSaleLabel(ele === null || ele === void 0 ? void 0 : ele.sys_user_fullname, ele === null || ele === void 0 ? void 0 : ele.sys_user_nname)
                });
            });
            setOptionSale(arr);
        }
    }, [
        allSetUserReducer
    ]);
    useEffect(function() {
        if (getReportVisitSaleMonthReducer.data) {
            var apiData = getReportVisitSaleMonthReducer.data.data;
            // สร้าง columns แบบ dynamic
            if (apiData.columns) {
                var columnOrder = [
                    "sale_name",
                    "managed_shop_count",
                    "active_store_count",
                    "compensation_rate",
                    "visited_shop_count",
                    "unvisited_shop_count",
                    "total"
                ];
                var orderedColumns = _to_consumable_array(apiData.columns).sort(function(a, b) {
                    var aIndex = columnOrder.indexOf(a.key);
                    var bIndex = columnOrder.indexOf(b.key);
                    if (aIndex === -1 && bIndex === -1) {
                        return 0;
                    }
                    if (aIndex === -1) {
                        return 1;
                    }
                    if (bIndex === -1) {
                        return -1;
                    }
                    return aIndex - bIndex;
                });
                var dynamicColumns = orderedColumns.map(function(col, index) {
                    // ปรับแต่งตามความต้องการ
                    var baseColumn = {
                        name: col.label,
                        selector: function(row) {
                            return row[col.key];
                        },
                        center: true
                    };
                    // ตัวอย่าง: คอลัมน์แรก (เซลส์) ให้กว้างกว่า
                    if (index === 0) {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            width: "250px",
                            center: false,
                            left: true
                        });
                    }
                    // ตัวอย่าง: คอลัมน์รวม ให้กว้างพอสมควร
                    if (col.key === "managed_shop_count") {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            name: "จำนวนที่ดูแล",
                            width: "200px",
                            cell: function(row) {
                                return "".concat(Number(row.managed_shop_count) || 0, " สาขา (").concat(Number(row.managed_unique_shop_count) || 0, " ร้านค้า)");
                            }
                        });
                    }
                    if (col.key === "active_store_count") {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            name: "Active Store",
                            width: "230px",
                            cell: function(row) {
                                var percentage = Math.round(Number(row.active_store_percentage) || 0);
                                return "".concat(Number(row.active_store_count) || 0, " สาขา (").concat(Number(row.active_unique_shop_count) || 0, " ร้านค้า) (").concat(percentage, " %)");
                            }
                        });
                    }
                    if (col.key === "compensation_rate") {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            name: "ค่าตอบแทน",
                            width: "130px",
                            cell: function(row) {
                                var _row_compensation_rate;
                                var rate = Number((_row_compensation_rate = row.compensation_rate) !== null && _row_compensation_rate !== void 0 ? _row_compensation_rate : 0);
                                return /*#__PURE__*/ _jsxs("span", {
                                    style: {
                                        color: getCompensationColor(rate),
                                        fontWeight: 700
                                    },
                                    children: [
                                        rate.toFixed(2),
                                        " %"
                                    ]
                                });
                            }
                        });
                    }
                    if (col.key === "visited_shop_count") {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            name: "สาขาที่เยี่ยมชมแล้ว",
                            width: "200px",
                            cell: function(row) {
                                return /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-link p-0 text-decoration-none",
                                    style: {
                                        color: "#565DFF",
                                        fontWeight: 500
                                    },
                                    onClick: function() {
                                        return handleOpenBranchModal("สาขาที่เยี่ยมชมแล้ว - ".concat(row.sale_name || "-"), row.visited_branches || []);
                                    },
                                    children: "".concat(Number(row[col.key]) || 0, " สาขา (").concat(Number(row.visited_unique_shop_count) || 0, " ร้านค้า)")
                                });
                            }
                        });
                    }
                    if (col.key === "unvisited_shop_count") {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            name: "สาขาที่ไม่ได้เยี่ยมชม",
                            width: "210px",
                            cell: function(row) {
                                return /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-link p-0 text-decoration-none",
                                    style: {
                                        color: "#565DFF",
                                        fontWeight: 500
                                    },
                                    onClick: function() {
                                        return handleOpenBranchModal("สาขาที่ไม่ได้เยี่ยมชม - ".concat(row.sale_name || "-"), row.unvisited_branches || []);
                                    },
                                    children: "".concat(Number(row[col.key]) || 0, " สาขา (").concat(Number(row.unvisited_unique_shop_count) || 0, " ร้านค้า)")
                                });
                            }
                        });
                    }
                    if (col.key === "total") {
                        return _object_spread_props(_object_spread({}, baseColumn), {
                            width: "120px",
                            cell: function(row, index, column, id) {
                                return /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        color: "#565DFF",
                                        fontWeight: 500
                                    },
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        className: "me-2",
                                        to: "/report/reportstorevisitappointment/detail/".concat(moment(month).format("YYYY-MM"), "/").concat(row.sale_id),
                                        children: row[col.key]
                                    })
                                });
                            }
                        });
                    }
                    // คอลัมน์วันที่ทั่วไป
                    return _object_spread_props(_object_spread({}, baseColumn), {
                        width: "100px",
                        cell: function(row) {
                            var value = Number(row[col.key]) || 0;
                            return /*#__PURE__*/ _jsx("span", {
                                style: {
                                    color: value < 4 ? "#dc3545" : "inherit",
                                    fontWeight: value < 4 ? 600 : 400
                                },
                                children: value
                            });
                        }
                    });
                });
                setColumns(dynamicColumns);
            }
            // แปลงข้อมูล rows
            if (apiData.rows) {
                var filteredRows = apiData.rows;
                // กรองตาม saleId ถ้ามีการเลือก
                if (saleId) {
                    filteredRows = apiData.rows.filter(function(row) {
                        return row.sale_id === parseInt(saleId);
                    });
                }
                // แปลงข้อมูล
                var transformedData = filteredRows.map(function(row) {
                    var _row_compensation_rate;
                    return _object_spread({
                        sale_id: row.sale_id,
                        sale_name: saleDisplayMap.get(row.sale_id) || formatSaleLabel(row.sale_name, ""),
                        managed_shop_count: row.managed_shop_count || 0,
                        managed_unique_shop_count: row.managed_unique_shop_count || 0,
                        active_store_count: row.active_store_count || 0,
                        active_unique_shop_count: row.active_unique_shop_count || 0,
                        active_store_percentage: row.active_store_percentage || 0,
                        compensation_rate: (_row_compensation_rate = row.compensation_rate) !== null && _row_compensation_rate !== void 0 ? _row_compensation_rate : 0,
                        visited_shop_count: row.visited_shop_count || 0,
                        visited_unique_shop_count: row.visited_unique_shop_count || 0,
                        unvisited_shop_count: row.unvisited_shop_count || 0,
                        unvisited_unique_shop_count: row.unvisited_unique_shop_count || 0,
                        visited_branches: row.visited_branches || [],
                        unvisited_branches: row.unvisited_branches || [],
                        total: row.total || 0
                    }, row.data);
                });
                setTableData(transformedData);
            }
            // ตั้งค่า summary
            if (apiData.summary) {
                setSummary(apiData.summary);
            }
        }
    }, [
        getReportVisitSaleMonthReducer,
        saleDisplayMap,
        saleId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสรุปจำนวนนัดหมาย"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสรุปจำนวนนัดหมาย (ใบเยี่ยมชมร้านค้า) แยกตามเซลล์"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d5eafa] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(AddBusinessIcon, {})
                                            }),
                                            "นัดหมายทั้งหมด"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: (summary === null || summary === void 0 ? void 0 : summary.total_appointment) ? summary === null || summary === void 0 ? void 0 : summary.total_appointment : 0
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4 !bg-[#d4f3cd] !text-[#000]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: !isMobile ? "fs-20 mb-2" : "fs-18 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ _jsx(StoreIcon, {})
                                            }),
                                            "เซลล์ Active สูงสุด"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-18 mb-2 text-right",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    paddingRight: 10,
                                                    fontSize: 14
                                                },
                                                children: (summary === null || summary === void 0 ? void 0 : summary.top_active_sale) ? saleDisplayMap.get(summary === null || summary === void 0 ? void 0 : (_summary_top_active_sale = summary.top_active_sale) === null || _summary_top_active_sale === void 0 ? void 0 : _summary_top_active_sale.sale_id) || formatSaleLabel(summary === null || summary === void 0 ? void 0 : (_summary_top_active_sale1 = summary.top_active_sale) === null || _summary_top_active_sale1 === void 0 ? void 0 : _summary_top_active_sale1.sale_name, "") : ""
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "",
                                                children: (summary === null || summary === void 0 ? void 0 : summary.top_active_sale) ? summary === null || summary === void 0 ? void 0 : (_summary_top_active_sale2 = summary.top_active_sale) === null || _summary_top_active_sale2 === void 0 ? void 0 : _summary_top_active_sale2.total : 0
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3 pb-0",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4 pb-0",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาเดือน"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: month,
                                                onChange: function(date) {
                                                    return setMonth(date);
                                                },
                                                dateFormat: "yyyy-MM",
                                                showMonthYearPicker: true,
                                                className: "form-control px-2 mb-2 input-equal"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาเซลล์ที่ดูแล"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                options: optionSale,
                                                value: optionSale.find(function(opt) {
                                                    return opt.value === saleId;
                                                }) || "",
                                                menuPortalTarget: document.body,
                                                menuPosition: "fixed",
                                                styles: {
                                                    menuPortal: function(base) {
                                                        return _object_spread_props(_object_spread({}, base), {
                                                            zIndex: 9999
                                                        });
                                                    },
                                                    menu: function(base) {
                                                        return _object_spread_props(_object_spread({}, base), {
                                                            zIndex: 9999
                                                        });
                                                    }
                                                },
                                                onChange: function(e) {
                                                    setSaleId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body pt-0 px-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-3 p-3 rounded",
                                style: {
                                    backgroundColor: "#f8f9fa",
                                    border: "1px solid #e6e8eb"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fw-bold mb-2",
                                        children: "เงื่อนไขค่าตอบแทนตาม Active Store"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2",
                                        children: [
                                            "Active Store นับจากสาขาร้านที่ดูแลซึ่งมีใบจองที่สร้างในเดือนที่ค้นหา และเซลล์ยืนยันแล้ว โดยใบจองมีสถานะ ",
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: "รอส่งสินค้า"
                                            }),
                                            ",",
                                            " ",
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: "ส่งสินค้าแล้ว"
                                            }),
                                            " หรือ ",
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: "ชำระเงินแล้ว"
                                            }),
                                            " ",
                                            "(ใบจองหลายใบในสาขาเดียวกันนับเป็น 1 สาขา)"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        children: "เปอร์เซ็นต์ Active Store = จำนวนร้านค้า Active ไม่ซ้ำ \xf7 150 \xd7 100"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        children: "ร้านค้าที่เยี่ยมชมบางสาขาจะนับทั้งในกลุ่มเยี่ยมชมแล้วและกลุ่มที่ยังไม่ได้เยี่ยมชม"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex flex-wrap gap-3",
                                        children: COMPENSATION_LEVELS.map(function(level) {
                                            return /*#__PURE__*/ _jsxs("span", {
                                                style: {
                                                    color: level.color,
                                                    fontWeight: 600
                                                },
                                                children: [
                                                    level.label,
                                                    " = ",
                                                    level.rate
                                                ]
                                            }, level.label);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("style", {
                                children: "\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(-n + 6),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(-n + 6) {\n              position: sticky !important;\n              background-color: #ffffff !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(-n + 6) {\n              z-index: 3 !important;\n              background-color: #f5f5f7 !important;\n            }\n\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(-n + 6) {\n              z-index: 2 !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n              left: 0 !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n              left: 250px !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n              left: 450px !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(4) {\n              left: 680px !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(5),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(5) {\n              left: 810px !important;\n            }\n\n            .visit-summary-table .rdt_TableHeadRow .rdt_TableCol:nth-child(6),\n            .visit-summary-table .rdt_TableRow .rdt_TableCell:nth-child(6) {\n              left: 1010px !important;\n              box-shadow: 4px 0 6px rgba(0, 0, 0, 0.1) !important;\n            }\n          "
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "visit-summary-table",
                                style: {
                                    width: "100%",
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ _jsx(DataTableLayout, {
                                    item: tableData,
                                    columns: columns,
                                    isSelectRows: false,
                                    PerPage: 10
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: branchModal.show,
                onHide: handleCloseBranchModal,
                centered: true,
                size: "lg",
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: branchModal.title || "รายละเอียดสาขา"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Body, {
                        children: branchModal.items && branchModal.items.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("style", {
                                    children: "\n                .branch-modal-table th:first-child,\n                .branch-modal-table td:first-child {\n                  display: none;\n                }\n              "
                                }),
                                /*#__PURE__*/ _jsxs(Table, {
                                    responsive: true,
                                    hover: true,
                                    className: "branch-modal-table",
                                    children: [
                                        /*#__PURE__*/ _jsx("thead", {
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        style: {
                                                            width: "80px"
                                                        },
                                                        children: "ลำดับ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ชื่อร้านค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "สาขา"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("tbody", {
                                            children: branchModal.items.map(function(item, index) {
                                                return /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: item.shop_name || "-"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: item.branch_name || "-"
                                                        })
                                                    ]
                                                }, item.branch_id || "".concat(item.shop_name, "-").concat(index));
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "text-center py-3",
                            children: "ไม่พบข้อมูล"
                        })
                    })
                ]
            })
        ]
    });
}
export function ReportStoreVisitAppointmentDetail() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var param = useParams();
    var dateMonth = useMemo(function() {
        return param.dateMonth ? param.dateMonth : null;
    }, [
        param.dateMonth
    ]);
    var saleId = useMemo(function() {
        return param.saleId ? param.saleId : null;
    }, [
        param.saleId
    ]);
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), shopId = _useState1[0], setShopId = _useState1[1];
    var getReportVisitSaleMonthListReducer = useAppSelector(function(state) {
        return state.getReportVisitSaleMonthListReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var formatSaleLabel = function(fullName, nickName) {
        var name = fullName ? fullName.trim() : "";
        var nname = nickName ? nickName.trim() : "";
        if (name && nname) {
            return "".concat(name, " (").concat(nname, ")");
        }
        if (name) {
            return name;
        }
        if (nname) {
            return nname;
        }
        return "-";
    };
    var saleDisplayMap = useMemo(function() {
        var _allSetUserReducer_data;
        var saleMap = new Map();
        if ((_allSetUserReducer_data = allSetUserReducer.data) === null || _allSetUserReducer_data === void 0 ? void 0 : _allSetUserReducer_data.data) {
            allSetUserReducer.data.data.filter(function(user) {
                return user.sys_user_role_id == 3;
            }).forEach(function(user) {
                saleMap.set(user.sys_user_id, formatSaleLabel(user.sys_user_fullname, user.sys_user_nname));
            });
        }
        return saleMap;
    }, [
        allSetUserReducer.data
    ]);
    var optionShop = useMemo(function() {
        var shopMap = new Map();
        datalist.forEach(function(item) {
            if (!item.vs_visit_shid) {
                return;
            }
            if (!shopMap.has(item.vs_visit_shid)) {
                shopMap.set(item.vs_visit_shid, {
                    value: item.vs_visit_shid,
                    label: item.vs_visit_shopname || "-"
                });
            }
        });
        return [
            {
                value: "",
                label: "ทั้งหมด"
            }
        ].concat(_to_consumable_array(Array.from(shopMap.values())));
    }, [
        datalist
    ]);
    var filteredData = useMemo(function() {
        if (!shopId) {
            return datalist;
        }
        return datalist.filter(function(item) {
            return String(item.vs_visit_shid) === String(shopId);
        });
    }, [
        datalist,
        shopId
    ]);
    useEffect(function() {
        dispatch(getReportVisitSaleMonthList({
            month: dateMonth,
            saleid: parseInt(saleId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        saleId,
        dateMonth
    ]);
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getReportVisitSaleMonthListReducer.isFetching);
        if (getReportVisitSaleMonthListReducer.data) {
            setDatalist(getReportVisitSaleMonthListReducer.data.data);
        }
    }, [
        getReportVisitSaleMonthListReducer
    ]);
    var columns = [
        {
            name: "รหัสใบเยี่ยมชม",
            selector: function(row) {
                return row.vs_visit_code;
            },
            center: "true",
            width: "150px"
        },
        {
            name: "วัน-เวลา ที่นัดหมาย",
            selector: function(row) {
                return row.vs_visit_appointmentdate ? moment.parseZone(row.vs_visit_appointmentdate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "วัน-เวลา ที่เข้าพบ",
            selector: function(row) {
                return row.vs_visit_visitdate ? moment.parseZone(row.vs_visit_visitdate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "ชื่อร้าน-สาขา",
            selector: function(row) {
                return row.vs_visit_shopname;
            },
            // center: "true",
            width: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.vs_visit_shopname
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: "(".concat(row.vs_visit_branchname, ")")
                        })
                    ]
                });
            }
        },
        {
            name: "เซลล์ผู้ดูแล",
            selector: function(row) {
                return saleDisplayMap.get(row.vs_visit_saleid) || formatSaleLabel(row.vs_visit_salename, "");
            },
            // center: "true",
            width: "180px"
        },
        {
            name: "เซลล์ซัพพอร์ต",
            selector: function(row) {
                return row.vs_visit_supportid;
            },
            // center: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return row.vs_visit_supportid ? row.SupportUser.sys_user_fullname : "-";
            }
        },
        {
            name: "วัตถุประสงค์",
            selector: function(row) {
                return row.VsObjective && row.VsObjective.length > 0 ? row.VsObjective.map(function(obj) {
                    return obj.vs_objective_name;
                }).join(" , ") : "-";
            },
            // center: "true",
            width: "300px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.vs_visit_status;
            },
            center: "true",
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Tooltip, {
                    title: "เปลี่ยนสถานะใบเยี่ยมชมร้านค้า",
                    children: /*#__PURE__*/ _jsx(ButtonMui, {
                        variant: "contained",
                        endIcon: /*#__PURE__*/ _jsx(ArrowDropDownIcon, {}),
                        className: "px-2 py-1 text-center",
                        disabled: row.vs_visit_status == 3 ? true : false,
                        style: {
                            color: row.vs_visit_status == 4 && "rgba(224, 13, 235, 1)" || row.vs_visit_status == 3 && "rgba(211, 47, 47, 1)" || row.vs_visit_status == 2 && "rgba(255, 255, 255, 1)" || row.vs_visit_status == 1 && "rgba(253, 180, 40, 1)",
                            backgroundColor: row.vs_visit_status == 4 && "rgba(248, 193, 249, 1)" || row.vs_visit_status == 3 && "rgba(253, 237, 237, 1)" || row.vs_visit_status == 2 && "rgba(16, 176, 42, 1)" || row.vs_visit_status == 1 && "rgba(255, 246, 229, 1)",
                            borderRadius: "20px",
                            width: "130px"
                        },
                        children: row.vs_visit_status_text == "เยี่ยมชม" ? "เยี่ยมชมแล้ว" : row.vs_visit_status_text
                    })
                });
            }
        },
        {
            name: "วันที่ทำรายการ",
            selector: function(row) {
                return row.vs_visit_credate ? moment.parseZone(row.vs_visit_credate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "190px"
        },
        {
            name: "หมายเหตุการยกเลิก",
            selector: function(row) {
                return row.vs_visit_cancelremark ? row.vs_visit_cancelremark : "-";
            },
            // center: "true",
            width: "180px"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสรุปจำนวนนัดหมาย"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายละเอียด"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: "รายละเอียดใบเยี่ยมชมร้านค้าแยกตามเซลล์"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3  mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pb-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row gx-xl-4",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "col-xl-4 col-md-6",
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "mb-2 form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1 z-3",
                                            children: "ค้นหาร้านค้า"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            as: "select",
                                            className: "w-100 select-st-3 z-2",
                                            placeholder: "ค้นหาร้านค้า",
                                            options: optionShop,
                                            value: optionShop.find(function(opt) {
                                                return opt.value === shopId;
                                            }) || "",
                                            menuPortalTarget: document.body,
                                            menuPosition: "fixed",
                                            styles: {
                                                menuPortal: function(base) {
                                                    return _object_spread_props(_object_spread({}, base), {
                                                        zIndex: 9999
                                                    });
                                                },
                                                menu: function(base) {
                                                    return _object_spread_props(_object_spread({}, base), {
                                                        zIndex: 9999
                                                    });
                                                }
                                            },
                                            onChange: function(e) {
                                                setShopId(e ? e.value : "");
                                            },
                                            isClearable: true
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pt-0 px-0",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    });
}
